// @flow
import type {
  ImportJobsToolOperation,
} from '../types'

export default ({
  operations: [],
}: {
  operations: Array<ImportJobsToolOperation>,
})
